import type { IInputNullableFloatModelValueType, IInputNullableFloatPropsWithoutModelValue } from '@/components';
import { reactive, type Ref } from 'vue';
import { DropdownItemBase } from './DropdownItemBase';

type IDropdownItemFloatNullableInput = {
    [K in keyof IInputNullableFloatPropsWithoutModelValue]: undefined extends IInputNullableFloatPropsWithoutModelValue[K]
        ? IInputNullableFloatPropsWithoutModelValue[K] | Ref<Exclude<IInputNullableFloatPropsWithoutModelValue[K], undefined>> | undefined
        : IInputNullableFloatPropsWithoutModelValue[K] | Ref<IInputNullableFloatPropsWithoutModelValue[K]>;
};

// TODO: I guess this could be a generic class with a PropsType and a modelValue type7
// I'm not sure how to make a type with generics tho
export class DropdownItemFloatNullableInput extends DropdownItemBase {
    modelValue: Ref<IInputNullableFloatModelValueType>;

    props: IInputNullableFloatPropsWithoutModelValue;

    get uniqueLoopKey() {
        return `${this.props.id}-${this.props.label}-${this.props.placeholder}-${this.props.icon}`;
    }

    private abuseBlocker: boolean = false;

    private constructor(
        modelValue: Ref<IInputNullableFloatModelValueType>,
        props: IDropdownItemFloatNullableInput,
        hideDropDownItem?: Ref<boolean>,
    ) {
        super();
        this.modelValue = modelValue;
        this.hideDropDownItem = hideDropDownItem;
        this.props = reactive(props);
    }

    public static create(
        options: { modelValue: Ref<IInputNullableFloatModelValueType> } & IDropdownItemFloatNullableInput &
            Pick<DropdownItemBase, 'hideDropDownItem'>,
    ): DropdownItemFloatNullableInput {
        const { modelValue, hideDropDownItem, ...props } = options;
        return new DropdownItemFloatNullableInput(modelValue, props, hideDropDownItem);
    }
}
